import React from 'react';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import queryString from 'query-string';

function Home(){
  var location = useLocation();
  let params = queryString.parse(location.search);
  return (
    <App params={params}></App>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      </Switch>
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

